<script>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/axiosConfig';
import { serverUrl } from '@/serverUrl';
import Swal from 'sweetalert2';

export default {
  name: 'VideoGallery',
  setup() {
    const fileInput = ref(null);
    const videos = ref([]);

    const handleDrop = (event) => {
      event.preventDefault();
      const files = event.dataTransfer.files;
      handleFiles(files);
    };

    const openFileManager = () => {
      fileInput.value.click();
    };

    const handleFiles = (files) => {
      console.log(files);
      uploadFiles(files);
    };

    const onFileChange = (event) => {
      const files = event.target.files;
      handleFiles(files);
    };

    const uploadFiles = async (files) => {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('videos', files[i]);
      }

      try {
        const response = await axiosInstance.post('/upload/videos', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log('Video caricati con successo:', response.data);
        loadVideos();
      } catch (error) {
        console.error('Errore nel caricamento dei video:', error);
        alert('Errore nel caricamento dei video');
      }
    };

    const loadVideos = async () => {
      try {
        const response = await axiosInstance.get('/upload/videos');
        videos.value = response.data.videos; // Assumi che response.data sia un array di URL dei video
      } catch (error) {
        console.error('Errore nel caricamento dei video:', error);
        alert('Errore nel caricamento dei video');
      }
    };

    const onDeleteVideo = (id) => {
      Swal.fire({
        text: 'Sei sicuro di voler eliminare questo video dalla gallery?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sì, elimina!',
        cancelButtonText: 'Annulla'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axiosInstance.delete(`/upload/videos/${id}`);
            // Rimuovi il video dall'elenco
            videos.value = videos.value.filter(video => video._id !== id);
            Swal.fire(
              'Eliminato!',
              'Il video è stato eliminato.',
              'success'
            );
          } catch (error) {
            console.error('Errore nell\'eliminazione del video:', error);
            Swal.fire(
              'Errore!',
              'Si è verificato un errore durante l\'eliminazione del video.',
              'error'
            );
          }
        }
      });
    };

    // Carica i video al montaggio del componente
    onMounted(loadVideos);

    return {
      fileInput,
      videos,
      handleDrop,
      openFileManager,
      onFileChange,
      onDeleteVideo,
      serverUrl
    };
  }
};
</script>

<template src="./VideoGallery.html" />

<style scoped>

</style>